var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#328332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9656 51.7281L28.9625 49.925L49.9625 38.0437V51.7281H49.9656ZM49.9656 65.6656V87.3531C42.6625 75.9844 34.6125 63.4719 28.125 53.3437C35.7812 57.6562 43.775 62.1625 49.9656 65.6656ZM49.9656 34.2031L28.125 46.3906L49.9656 12.5V34.2031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.968 49.925L49.9648 51.7281V38.0437L70.968 49.925ZM49.9648 65.6688C56.1523 62.1688 64.143 57.6562 71.8023 53.3438C65.3148 63.475 57.2648 75.9875 49.9648 87.35V65.6688ZM49.9648 34.2031V12.5L71.8023 46.3906L49.9648 34.2031Z",
    fill: "white",
    fillOpacity: 0.601
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9648 51.7279L70.9648 49.9248L49.9648 61.7217V51.7279Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.603,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9641 51.7279L28.9609 49.9248L49.9641 61.7217V51.7279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/ETC.8520eaf27229893cc3bbb5587b36d1ee.svg";
export { ForwardRef as ReactComponent };